import styled, { css } from 'styled-components'

export const SideBarContainer = styled.div`
  background-color: #fdfdff;
  border-right: 2px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  position: absolute;
  width: 100px;
`

export const ButtonContainer = styled.div`
  display: flex;
  height: 50px;
  margin-top: 26px;
  width: 100%;

  * {
    cursor: pointer;
  }
`

export const IconContainer = styled.div`
  ${({ selected }) => css`
    position: relative;
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 50px;
    justify-content: center;
    width: calc(100% - 4px);

    ${selected &&
    css`
      &::after {
        content: '';
        position: absolute;
        background-color: #be9137;
        border-radius: 0 4px 4px 0;
        height: 100%;
        left: 0;
        width: 4px;
      }
    `}
  `}
`
